import { createApp } from 'vue';
import Antd from 'ant-design-vue/es';
import App from './App';
import { Button } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import CryptoJS from 'crypto-js';
import router from './router'; // 引入路由

createApp(App)
  .use(Antd)
  .use(CryptoJS)
  .use(Button)
  .use(router) // 使用路由
  .mount('#app');